import { Component, OnInit, Inject } from '@angular/core';

import { Puc } from "../../entidades";

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FinanzasService } from 'app/finanzas/finanzas.service';


@Component({
  selector: 'app-agg-puc',
  templateUrl: './agg-puc.component.html',
  styleUrls: ['./agg-puc.component.css']
})
export class AggPucComponent implements OnInit {

  cuenta: Puc = new Puc();

  listPuc: Array<Puc> = this.datos.puc; 

  constructor(  
    private service: FinanzasService,
    public dialogRef: MatDialogRef<AggPucComponent>,
    @Inject(MAT_DIALOG_DATA) private datos) { 

    this.cuenta['idEmpresa'] = this.datos.idEmpresa;
  }

  ngOnInit(  ) {
    
    if (this.buscarid( this.datos.id)){ 
      this.service.getPucId(this.definirEmpresa(), this.datos.id)
        .subscribe( ( [resp]:Array<Puc> ) => {
          this.cuenta = resp;
          console.log(resp)
          
      })
    }
  }
  
  // trae la cuenta que se le indique por id
  buscarid( id ){
    return this.listPuc.find(puc => puc.id == id )
  }


  definirEmpresa(){
    let empresaTemp;
    if(  this.datos.empresa != undefined  ){
      empresaTemp = this.datos.empresa        
    }

    else{  empresaTemp = this.datos.idEmpresa }

    return empresaTemp
  }

  

  


  

}
